import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { createLoadOrder } from "../../../../actions/order";
import { PublicViewTemplate } from "../../../../models/PublicViewTemplate";
import { usePublicViewEntityContext } from "../../../../context/PublicViewEntityProvider";
import SelectTemplatePopup from "./SelectTemplatePopup";

export default function SelectTemplatePopupWithContext(props) {
  const {
    entityLayoutId,
    entityTemplateId,
    onUpdateEntity,
    isShop,
    entity,
    entityOrderId,
    labelTitle
  } = usePublicViewEntityContext();

  const dispatch = useDispatch();

  const {
    onClose,
    layouts,
    templateData,
    selectedTheme,
    selectedTemplate,
    initialFilters,
    initialCategory,
    onClickFavouriteTheme,
    zIndex,
    ...otherProps
  } = props;

  const handleClickSelect = useCallback((theme) => {
    if (!theme || !theme.template_type) {
      return;
    }

    if (theme.template_type === 'TEMPLATE') {
      if (!theme.parent_id || !theme.public_view_template_id) {
        console.warn('Missing required template properties:', theme);
        return;
      }

      onUpdateEntity('public_view_layout_id', entityLayoutId)(theme.parent_id);
      onUpdateEntity('public_view_template_id', entityTemplateId)(theme.public_view_template_id);
      if ([
        PublicViewTemplate.CATEGORIES_CAROUSEL,
        PublicViewTemplate.LEFT_NAV_HERO_IMAGE,
      ].includes(theme.public_view_template_name)) {
        // reload order info with categories
        dispatch(createLoadOrder(entityOrderId, true));
      }
    } else {
      if (!theme.public_view_template_id) {
        console.warn('Missing public_view_template_id for layout:', theme);
        return;
      }
      onUpdateEntity('public_view_layout_id', entityLayoutId)(theme.public_view_template_id);
      onUpdateEntity('public_view_template_id', entityTemplateId)('');
    }
  }, [entityLayoutId, entityTemplateId, entityOrderId, onUpdateEntity, dispatch]);

  return (
    <SelectTemplatePopup
      onClose={onClose}
      layouts={layouts}
      templateData={templateData}
      selectedTheme={selectedTheme}
      selectedTemplate={selectedTemplate}
      initialFilters={initialFilters}
      initialCategory={initialCategory}
      onClickFavouriteTheme={onClickFavouriteTheme}
      zIndex={zIndex}
      onClickSelect={handleClickSelect}
      isShop={isShop}
      entity={entity}
      labelTitle={labelTitle}
      {...otherProps}
    />
  );
}
